<template>
  <div class="upload">
    <el-upload
      action=""
      class="upload-demo"
      :auto-upload="false"
      :show-file-list="true"
      :http-request="() => {}"
      :on-change="onFileChanged"
      :on-remove="onFileRemove"
      :file-list="fileList"
      multiple>
      <el-button size="small" type="primary">上传附件</el-button>
    </el-upload>
  </div>
</template>

<script>
import bookingDiagnoseService from "@/apis/bookingDiagnose/index.js";

export default {
  name: "upload",
  props: {
    type: {
      type: Number || String,
      default: 1,
    },
  },
  data() {
    return {
      fileList: [],
    };
  },
  methods: {
    onFileChanged(file, fileList) {
      this.$nextTick(() => {
        file.status = "uploading";
      });
      this.fileList = fileList;
      // 获取并上传文件的base64格式
      const reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = (e) => {
        const base64 = e.target.result;
        // 删掉base64中的前缀
        const base64Arr = base64.split(",");
        const base64Str = base64Arr[1];

        const formData = new FormData();
        formData.append("file", file.raw);
        const params = {
          booking_type: this.type,
          booking_mode: 1,
          base64: base64Str,
          file_name: file.name,
        };
        this.$emit("imageUpdate", true);
        const onUploadProgress = (progressEvent) => {
          const percentage =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          file.percentage = percentage;
          this.$forceUpdate();
        };
        this.fileChange(fileList);
        bookingDiagnoseService
          .uploadDocument(params, onUploadProgress)
          .then((res) => {
            file.file_id = res.doc_id;
            file.status = "success";
            this.fileChange(fileList);
            this.$emit("imageUpdate", false);
          });
      };
    },
    onFileRemove(file, fileList) {
      this.fileList = fileList;
      this.fileChange(fileList);
    },
    fileChange(fileList) {
      this.$emit("change", fileList);
    },
  },
};
</script>

<style lang="scss" scoped></style>
